import React from 'react'
import { styled } from '@mui/material'
import Badge from '@mui/material/Badge'

import { useCartSummaryQuery } from 'shared/store/useCartSummary'
import { useProfileQuery } from 'shared/store/useProfile'
import { ShoppingCartOutlined, EmailOutlined } from '@mui/icons-material'
import { useCartProductsContext } from 'shared/context/CartProducts'

interface Props {
   badgeType: 'CART' | 'MESSAGES' | 'CART_HEADER'
}

export default function BadgeIcon({ badgeType }: Props) {
   // const { data: cartData } = useCartSummaryQuery()
   const { data: profileData } = useProfileQuery()
   const { productsCount: cartProductsCount } = useCartProductsContext()
   // const cartProductsCount = cartData?.products.length
   const messagesCount = profileData?.unreadMessages

   function renderBadge() {
      switch (badgeType) {
         case 'CART': {
            return (
               <StyledBadge badgeContent={cartProductsCount} color="primary">
                  <ShoppingCartOutlined />
               </StyledBadge>
            )
         }
         case 'CART_HEADER': {
            return (
               <StyledBadge badgeContent={cartProductsCount} color="primary">
                  <ShoppingCartOutlined sx={{ fontSize: 27 }} />
               </StyledBadge>
            )
         }
         case 'MESSAGES': {
            return (
               <StyledBadge badgeContent={messagesCount} color="primary">
                  <EmailOutlined />
               </StyledBadge>
            )
         }
         default:
            return null
      }
   }

   return renderBadge()
}
const StyledBadge = styled(Badge)({
   '& .MuiBadge-badge': { color: 'white', fontWeight: 'normal' },
})
